import React, { useEffect, useState } from 'react';
import { Col, Spinner } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { advanceSettingAdvancePaymentsRequest } from '../../../requests/advanceSettings';
import Icon from '../../Icons';
import HRDashboardStyled from '../../HRDashboardStyled';

const PendingRequests = ({ cards, handleMoreInfoButton, showSpinner }) => {
  const dispatch = useDispatch();
  const [hasTabsRequest, setHasTabsRequest] = useState(1);
  const pendingCard = hasTabsRequest > 0 ? cards?.cardBoss?.totalRequestsBossCount : 0;

  const fetchAdvancePayments = () => {
    advanceSettingAdvancePaymentsRequest({
      dispatch,
      params: {
        codes: [
          'legal_holiday',
          'progressive_holiday',
          'additional_days',
          'paid_leave',
          'without_paid_leave',
          'administrative_days',
          'shift_change',
          'loan_request',
          'advance_payment_request'
        ]
      },
      successCallback: response => {
        setHasTabsRequest(response.data.filter(setting => setting.text_value !== 'false').length);
      }
    });
  };

  useEffect(fetchAdvancePayments, []);

  return (
    <>
      {showSpinner ? (
        <Col className="mt-5">
          <div className="containerSpinnerLoadDash mb-5">
            <Spinner animation="border" variant="primary" />
          </div>
        </Col>
      ) : (
        <>
          <HRDashboardStyled
            title={pendingCard}
            label="Solicitudes Pendientes"
            labelColor="#827f7f"
            TopHeaderColor="#fff"
            GeneralColor="#21653b"
            subtitle="Solicitudes pendientes por Aprobar/Firmar"
            TypeCard="OnlyInformation"
            onRequest={false}
            Downloadable={false}
            labelFontSize="12px"
          />
          {
            <button
              type="button"
              onClick={handleMoreInfoButton}
              style={{
                border: '1px solid #65b68f',
                backgroundColor: '#65b68f',
                position: 'absolute',
                right: 20,
                bottom: 10
              }}
            >
              <Icon icon="search" height="25px" width="16px" color="white" />
            </button>
          }
        </>
      )}
    </>
    //         {hasTabsRequest > 0 ? (
    //           <Col sm={12} md={8} xs={12} className="mb-3 mt-4">
    //             <p className="text-dark-bold text-center">Solicitudes pendientes por Aprobar</p>
    //           </Col>
    //         ) : (
    //           <p className="text-dark-bold text-center" style={{ marginTop: '50px' }}>
    //             No tienes solicitudes asociadas
    //           </p>
    //         )}
    //       </Row>
  );
};

export default PendingRequests;
